import get from 'lodash/get';

export default function createService(props) {
  return {
    getUser: () => {
      const getNavianceClaim = (token, claim) => get(token, `https://oauth.naviance.com/oauth/claims/${claim}`, '');
      const jwt = get(props, 'viewer.jwtToken', '');
      const data = get(props, 'viewer.idToken', {});
      const cognitoInstitutionId = get(data, 'custom:institution', '');
      const cognitoRole = get(data, 'custom:role', '');
      const navianceInstitutionId = getNavianceClaim(data, 'school.id');
      const navianceRole = getNavianceClaim(data, 'community.admin') ? 'administrator' : 'member';
      const isNaviance = get(props, 'viewer.isNaviance');
      return {
        jwt,
        uuid: get(data, 'sub', ''),
        email: get(data, 'email', ''),
        firstName: get(data, 'given_name', ''),
        lastName: get(data, 'family_name', ''),
        institutionType: 'HS',
        institutionId: cognitoInstitutionId || navianceInstitutionId,
        role: cognitoRole || navianceRole,
        isNaviance,
      };
    },
  };
}
